import type { ExperienceDetails } from '@atlassian/jira-business-experience-tracking/src/types.tsx';
import type { FlagConfiguration } from '@atlassian/jira-flags';
import messages from './messages';

const PACKAGE_NAME = 'jiraBusinessList';

export const RANK_ISSUE_EXPERIENCE: ExperienceDetails = {
	experience: 'rankIssue',
	packageName: PACKAGE_NAME,
	teamName: 'keystone',
};

export const RANK_ITEM_FAIL_GENERIC_FLAG: FlagConfiguration = {
	type: 'error',
	title: messages.rankItemErrorTitle,
	description: messages.rankItemErrorDescription,
};

export const RANK_ITEM_FAIL_404_FLAG: FlagConfiguration = {
	type: 'error',
	title: messages.rankItemErrorTitle,
	description: messages.rankItem404ErrorDescription,
};

export const RANK_ITEM_FAIL_403_FLAG: FlagConfiguration = {
	type: 'error',
	title: messages.rankItemErrorTitle,
	description: messages.rankItem403ErrorDescription,
};
